import * as uuid from 'uuid';
import { getCurrentUnixTimeInSeconds } from '../util/date';
export const SessionStorageType = {
    UuidSessionId: 'session_id',
    AamazonPayParams: 'amazon_pay_params',
    SigninRedirect: 'signin_redirect',
    AndroidVersion: 'android_version',
    AndroidHasStepcoutPermission: 'android_has_stepcount_permission',
    AndroidHasWeightPermission: 'android_has_weight_permission',
    AndroidHasBodyFatPermission: 'android_has_bodyfat_permission',
    AndroidDeviceNotificationPermission: 'android_device_notification_permission',
    AndroidNotificationSettings: 'android_notification_settings',
    AndroidHasCameraPermission: 'android_has_camera_permission',
    CampaignCountdownStartTime: 'campaign_countdown_start_time',
    IsFromLpPaymentForm: 'isFromLpPaymentForm',
    SkipBeginnerMissionDialogAutoOpen: 'skip_beginner_mission_dialog_auto_open',
};
export class SessionStorage {
    constructor() {
        Object.defineProperty(this, "sessionStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: sessionStorage
        });
        Object.defineProperty(this, "expiresSeconds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3600 * 24
        });
    }
    setSkipBeginnerMissionDialogAutoOpen(shouldSkip) {
        this.sessionStorage.setItem(SessionStorageType.SkipBeginnerMissionDialogAutoOpen, JSON.stringify(shouldSkip));
    }
    consumeSkipBeginnerMissionDialogAutoOpen() {
        const data = this.sessionStorage.getItem(SessionStorageType.SkipBeginnerMissionDialogAutoOpen);
        const shouldSkip = data ? JSON.parse(data) : false;
        this.sessionStorage.removeItem(SessionStorageType.SkipBeginnerMissionDialogAutoOpen);
        return shouldSkip;
    }
    loadSession() {
        const data = this.sessionStorage.getItem(SessionStorageType.UuidSessionId);
        if (data) {
            const parsedData = JSON.parse(data);
            const expires = parsedData.expires;
            if (this.isExpired(expires)) {
                return null;
            }
            return parsedData;
        }
        return null;
    }
    /**
     * sessionを生成して返す
     */
    setupSession() {
        const unixTs = getCurrentUnixTimeInSeconds();
        const params = {
            session_id: uuid.v4(),
            expire: unixTs + this.expiresSeconds,
        };
        this.sessionStorage.setItem(SessionStorageType.UuidSessionId, JSON.stringify(params));
        return params;
    }
    remove(key) {
        this.sessionStorage.removeItem(key);
    }
    loadAmazonPayParams() {
        const data = this.sessionStorage.getItem(SessionStorageType.AamazonPayParams);
        return JSON.parse(data);
    }
    setAmazonPayParams(planId, campaignCode, queryParams) {
        // amazonCheckoutSessionId は保存しておく必要がなく、キャンセル後の再試行時に古いIDが使われてエラーになる可能性があるため削除しておく
        queryParams.delete('amazonCheckoutSessionId');
        const params = {
            planId,
            campaignCode,
            queryParams: queryParams.toString(),
        };
        this.sessionStorage.setItem(SessionStorageType.AamazonPayParams, JSON.stringify(params));
    }
    loadAndroidAppVersion() {
        const version = this.sessionStorage.getItem(SessionStorageType.AndroidVersion);
        return version;
    }
    loadAndroidStepcountPermission() {
        const hasPermission = this.sessionStorage.getItem(SessionStorageType.AndroidHasStepcoutPermission);
        return Boolean(parseInt(hasPermission, 10));
    }
    loadAndroidAnyHealthConnectPermission() {
        const hasStepPermission = Boolean(parseInt(this.sessionStorage.getItem(SessionStorageType.AndroidHasStepcoutPermission), 10));
        const hasWeightPermission = Boolean(parseInt(this.sessionStorage.getItem(SessionStorageType.AndroidHasWeightPermission), 10));
        const hasBodyFatPermission = Boolean(parseInt(this.sessionStorage.getItem(SessionStorageType.AndroidHasBodyFatPermission), 10));
        return hasStepPermission || hasWeightPermission || hasBodyFatPermission;
    }
    loadAndroidDeviceNotificationPermission() {
        const hasPermission = this.sessionStorage.getItem(SessionStorageType.AndroidDeviceNotificationPermission);
        return hasPermission === 'true';
    }
    loadAndroidCameraPermission() {
        const hasPermission = this.sessionStorage.getItem(SessionStorageType.AndroidHasCameraPermission);
        return hasPermission === 'true';
    }
    loadAndroidNotificationSettings() {
        const settings = this.sessionStorage.getItem(SessionStorageType.AndroidNotificationSettings);
        if (settings === null) {
            return null;
        }
        const parsed = JSON.parse(settings);
        // number（0 or 1）で保存されているので、booleanに変換する
        parsed.news = !!parsed.news;
        parsed.live = !!parsed.live;
        parsed.streakReminder = !!parsed.streakReminder;
        return parsed;
    }
    setSigninRedirect(path) {
        this.sessionStorage.setItem(SessionStorageType.SigninRedirect, path);
    }
    loadSigninRedirect() {
        return this.sessionStorage.getItem(SessionStorageType.SigninRedirect);
    }
    setCampaignCountdownStartTime(timestamp) {
        this.sessionStorage.setItem(SessionStorageType.CampaignCountdownStartTime, timestamp.toString());
    }
    loadCampaignCountdownStartTime() {
        const data = this.sessionStorage.getItem(SessionStorageType.CampaignCountdownStartTime);
        return data ? parseInt(data, 10) : null;
    }
    saveIsFromLpPaymentForm(v) {
        this.sessionStorage.setItem(SessionStorageType.IsFromLpPaymentForm, JSON.stringify(v));
    }
    loadIsFromLpPaymentForm() {
        const data = this.sessionStorage.getItem(SessionStorageType.IsFromLpPaymentForm);
        return data ? JSON.parse(data) : false;
    }
    removeCampaignCountdownStartTime() {
        this.sessionStorage.removeItem(SessionStorageType.CampaignCountdownStartTime);
    }
    isExpired(expires) {
        const unixTs = getCurrentUnixTimeInSeconds();
        return expires < unixTs;
    }
}
